import Vue from "vue";
import App from "./App.vue";
import http from "./axios";
import i18n, { getLocale, loadLocaleMessagesfromApi } from "./i18n";
import VeeValidate, { Rules } from "vee-validate";
import validationMessages from "vee-validate/dist/locale/en";
import validationMessagesIt from "vee-validate/dist/locale/it";
import mixins from "./mixins";
import VueMq from "vue-mq";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import store from "./store/store";
import router from "./router";
import PhoneNumber from "awesome-phonenumber";
import moment from "moment";
import _ from "lodash";
import Cookies from "js-cookie";
import parseDomain from "parse-domain";
import firebase from "firebase/app";
import "firebase/messaging";
import VueParallaxJs from "vue-parallax-js";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "./assets/scss/_global.scss";
import vuetify from "./plugins/vuetify";
import vue2Dropzone from "vue2-dropzone";

Vue.config.productionTip = false;
Vue.component("vue2Dropzone", vue2Dropzone);

const phoneRule = {
  getMessage(field, args) {
    return "The " + field + " must be a valid phone number";
  },
  validate(value, args) {
    let phoneNumber = new PhoneNumber(value, "IT");
    return phoneNumber.isValid();
  }
};

const agreementsProfilationRule = {
  getMessage(field, args) {
    return "The profiling field depends on marketing acceptance.";
  },
  validate(value, args) {
    return value === false;
  }
};

const phoneOrEmailRule = {
  getMessage(field, args) {
    return "The " + field + " must be either a valid phone number or e-mail";
  },
  validate(value, args) {
    let phoneNumber = new PhoneNumber(value, "IT");
    return Rules.email.validate(value) || phoneNumber.isValid();
  }
};

VeeValidate.Validator.extend("phoneOrEmail", phoneOrEmailRule);
VeeValidate.Validator.extend("phone", phoneRule);
VeeValidate.Validator.extend(
  "agreementsProfilation",
  agreementsProfilationRule
);

// Vue.use(VeeValidate, {
//   events: "",
//   i18nRootKey: "validations",
//   i18n,
//   dictionary: {
//     en: validationMessages,
//     it: validationMessagesIt
//   }
// });
Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity
  }
});
Vue.use(VueParallaxJs);
Vue.use(VueAwesomeSwiper);

Vue.filter("moment", value => {
  moment(value);
});

try {
  const firebaseConfig = {
    apiKey: "AIzaSyCPIJC-JHBYpoDu0uYyVIQ9Bz0TDiPDwEQ",
    authDomain: "fanize-ff3d6.firebaseapp.com",
    databaseURL: "https://fanize-ff3d6.firebaseio.com",
    projectId: "fanize-ff3d6",
    storageBucket: "",
    messagingSenderId: "699755804441",
    appId: "1:699755804441:web:0b832e8838f3e675dc7788"
  };

  firebase.initializeApp(firebaseConfig);

  Vue.prototype.$messaging = firebase.messaging();
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(registration => {
      Vue.prototype.$messaging.useServiceWorker(registration);
    })
    .catch(err => {
      console.log(err);
    });
} catch (e) {}

Vue.component("loader", ScaleLoader);

Vue.prototype.$http = http;
Vue.prototype.moment = moment;

Vue.directive("gaddress", {
  // When the bound element is inserted into the DOM...
  inserted(el, binding, vnode) {
    var parentNode = el.parentNode;
    let autocomplete = new google.maps.places.Autocomplete(vnode.elm, {
      types: ["geocode"]
    });
    autocomplete.setFields(["address_components"]);
    autocomplete.inputId = vnode.elm.id;
    google.maps.event.addListener(autocomplete, "place_changed", function() {
      var place = autocomplete.getPlace();
      if (place.name) {
        var itemFull = _.get(
          document.querySelector(".pac-container .pac-item:first"),
          "textContent",
          ""
        );
        var itemQuery = _.get(
          document.querySelector(
            ".pac-container .pac-item:first .pac-item-query"
          ),
          "textContent",
          ""
        );
        var firstResult =
          itemQuery + ", " + itemFull.substring(itemQuery.length);
        if (firstResult === ", ") firstResult = "";
        vnode.elm.value = firstResult;
      }
      vnode.elm.dispatchEvent(new Event("input", { bubbles: true }));
      vnode.elm.dispatchEvent(new Event("change", { bubbles: true }));
    });
    google.maps.event.addDomListener(vnode.elm, "keydown", function(e) {
      var suggestion_selected =
        _.get(document.querySelector(".pac-item-selected"), "length", 0) > 0;
      if (!suggestion_selected) {
        var itemFull = _.get(
          document.querySelector(".pac-container .pac-item"),
          "textContent",
          ""
        );
        var itemQuery = _.get(
          document.querySelector(".pac-container .pac-item .pac-item-query"),
          "textContent",
          ""
        );
        var firstResult =
          itemQuery + ", " + itemFull.substring(itemQuery.length);
        if (firstResult === ", ") firstResult = "";
      }
      if (
        e.keyCode == 13 &&
        document.querySelector(".pac-container:visible").length
      ) {
        e.preventDefault();
      }
    });
    /*
                            google.maps.event.addDomListener((vnode.elm), 'blur', function (e) {
                                    vnode.elm.value=newNode.innerHTML;
                                    vnode.elm.dispatchEvent(new Event('input', {bubbles: true}));
                                    vnode.elm.dispatchEvent(new Event('change', {bubbles: true}));
        
                            });*/
  }
});
Vue.directive("gcity", {
  inserted(el, binding, vnode) {
    var parentNode = el.parentNode;
    let autocomplete = new google.maps.places.Autocomplete(vnode.elm, {
      types: ["(cities)"]
    });
    autocomplete.setFields(["address_components"]);
    autocomplete.inputId = vnode.elm.id;
    google.maps.event.addListener(autocomplete, "place_changed", function() {
      var place = autocomplete.getPlace();
      if (place.name) {
        var itemFull = _.get(
          document.querySelector(".pac-container .pac-item"),
          "textContent",
          ""
        );
        var itemQuery = _.get(
          document.querySelector(".pac-container .pac-item .pac-item-query"),
          "textContent",
          ""
        );
        var firstResult =
          itemQuery + ", " + itemFull.substring(itemQuery.length);
        if (firstResult === ", ") firstResult = "";
        vnode.elm.value = firstResult;
      }
      vnode.elm.dispatchEvent(new Event("input", { bubbles: true }));
      vnode.elm.dispatchEvent(new Event("change", { bubbles: true }));
    });
    google.maps.event.addDomListener(vnode.elm, "keydown", function(e) {
      var suggestion_selected =
        _.get(document.querySelector(".pac-item-selected"), "length", 0) > 0;
      if (!suggestion_selected) {
        var itemFull = _.get(
          document.querySelector(".pac-container .pac-item"),
          "textContent",
          ""
        );
        var itemQuery = _.get(
          document.querySelector(".pac-container .pac-item .pac-item-query"),
          "textContent",
          ""
        );
        var firstResult =
          itemQuery + ", " + itemFull.substring(itemQuery.length);
        if (firstResult === ", ") firstResult = "";
      }
      if (
        e.keyCode == 13 &&
        document.querySelector(".pac-container:visible").length
      ) {
        e.preventDefault();
      }
    });
    /*
                            google.maps.event.addDomListener((vnode.elm), 'blur', function (e) {
                                    let val=(newNode.innerHTML===', ')?'':newNode.innerHTML;
                                    vnode.elm.value=val;
                                    vnode.elm.dispatchEvent(new Event('input', {bubbles: true}));
                                    vnode.elm.dispatchEvent(new Event('change', {bubbles: true}));
        
                            });*/
  }
});

const tempTokenFromSocialLogin = Cookies.get("fanize_social_token");
const isSocialLoginPage = window.location.href.indexOf("socialLogin") !== -1;
const isAccessPage = window.location.href.indexOf("access") !== -1;
const parsedDomain = parseDomain(window.location.hostname);
let pushDeviceInfo = false;

if (
  tempTokenFromSocialLogin &&
  !isSocialLoginPage &&
  !isAccessPage &&
  parsedDomain
) {
  Cookies.remove("fanize_social_token", {
    domain: "." + parsedDomain.domain + "." + parsedDomain.tld
  });
  localStorage.setItem("token", tempTokenFromSocialLogin);
  store.state.authorization.access_token = tempTokenFromSocialLogin;
  http.defaults.headers.Authorization = "Bearer " + tempTokenFromSocialLogin;
  http.defaults.headers.common["Authorization"] =
    "Bearer " + tempTokenFromSocialLogin;
  http.defaults.headers["Authorization"] = "Bearer " + tempTokenFromSocialLogin;
  pushDeviceInfo = true;
}

if (!isSocialLoginPage /* && !isAccessPage */) {
  (async () => {
    try {
      const response = await http.get("/api/v1/campaign/info");
      store.state.campaign = response.data.data.campaign;
      store.state.brand = response.data.data.brand;
      const locale = getLocale();
      const localeResponse = await loadLocaleMessagesfromApi(getLocale());
      i18n.setLocaleMessage(locale, localeResponse[locale]);
      Vue.use(VeeValidate, {
        events: "",
        i18nRootKey: "validations",
        i18n,
        dictionary: {
          en: validationMessages,
          it: validationMessagesIt
        }
      });
      const VueConfig = {
        render: h => h(App),
        mixins: [mixins],
        store,
        router,
        i18n
      };

      document.title = response.data.data.campaign.name;
      store.commit("updateBrandLogo", _.get(response, "data.data.brand.logo"));
      const vm = new Vue({
        render: h => h(App),
        mixins: [mixins],
        store: store,
        router: router,
        i18n: i18n,
        vuetify
      }).$mount("#app");
      if (pushDeviceInfo) {
        vm.pushDeviceInfo();
      }
    } catch (error) {
      console.error(error);
      // window.location.replace("https://fanize.it");
    }
  })();
} else {
  new Vue({
    render: h => h(App),
    mixins: [mixins],
    store: store,
    router: router,
    i18n: i18n
  }).$mount("#app");
}

// if (!isSocialLoginPage) {
//   http
//     .get("/api/v1/campaign/info")
//     .then(response => {
//       store.commit(Mutations.UPDATE_CAMPAIGN, response.data.data.campaign);
//       store.state.brand = response.data.data.brand;

//       document.title = response.data.data.campaign.name;

//       store.commit("updateBrandLogo", _.get(response, "data.data.brand.logo"));
//       const vm = new Vue({
//         render: h => h(App),
//         mixins: [mixins],
//         store: store,
//         router: router,
//         i18n: i18n
//       }).$mount("#app");

//       if (pushDeviceInfo) {
//         vm.pushDeviceInfo();
//       }
//     })
//     .catch(error => {
//       window.location.replace("https://fanize.it");
//     });
// } else {
//   new Vue({
//     render: h => h(App),
//     mixins: [mixins],
//     store: store,
//     router: router,
//     i18n: i18n
//   }).$mount("#app");
// }
